import { render, staticRenderFns } from "./ModuleCreated.vue?vue&type=template&id=3e2890b2"
import script from "./ModuleCreated.vue?vue&type=script&lang=js"
export * from "./ModuleCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports